"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var app_1 = require("./app");
var Component = /** @class */ (function () {
    function Component() {
        this.skipInitIfNotOnPage = true;
        app_1.ComponentService.AddComponent(this);
    }
    Component.prototype.SetPendingUpdate = function () {
        app_1.ComponentService.AddPendingUpdateComponent(this);
    };
    return Component;
}());
exports.Component = Component;
